import { render, staticRenderFns } from "./ReceiveEmergencyTransportPatientTable.vue?vue&type=template&id=2112282b&scoped=true&lang=pug"
import script from "./ReceiveEmergencyTransportPatientTable.vue?vue&type=script&lang=ts"
export * from "./ReceiveEmergencyTransportPatientTable.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveEmergencyTransportPatientTable.vue?vue&type=style&index=0&id=2112282b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112282b",
  null
  
)

export default component.exports